"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const analytics_1 = require("@completeanatomy/analytics");
const auth_1 = require("@completeanatomy/auth");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const user_1 = require("@completeanatomy/user");
const styled_components_1 = __importDefault(require("styled-components"));
function AccessPopupBottomPanel({ className, onClose = () => { }, }) {
    const auth = (0, auth_1.useAuth)();
    const bridge = (0, bridge_1.useBridge)();
    const currentUser = (0, user_1.useUser)();
    const analytics = (0, analytics_1.useAnalytics)();
    const onStore = () => {
        /**
         * @todo replace
         *
         * Hack for legacy code access
         */
        if (typeof window.onGoToStore === 'function') {
            window.onGoToStore();
        }
        onClose();
    };
    const onGoRestore = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.restorePurchase();
        onClose();
    };
    const onLogin = () => {
        auth === null || auth === void 0 ? void 0 : auth.authenticate();
        analytics.log('SignInPressed');
        // @ts-ignore
        window.navigateBack = true;
        // @ts-ignore -- @todo replace with navigate from react-router-dom
        window.AppShell.AppRouter.navigate(`${auth_1.Route.Base}/${auth_1.Route.InterimScreen}/${auth_1.Route.InterimScreenOpen}`, {
            state: {
                process: auth_1.AuthProcess.SignIn,
            },
        });
        onClose();
    };
    const onGoTry = () => {
        auth === null || auth === void 0 ? void 0 : auth.signUp();
        analytics.log('TryItFreePressed');
        // @ts-ignore
        window.navigateBack = true;
        // @ts-ignore -- @todo replace with navigate from react-router-dom
        window.AppShell.AppRouter.navigate(`${auth_1.Route.Base}/${auth_1.Route.InterimScreen}/${auth_1.Route.InterimScreenOpen}`, {
            state: {
                process: auth_1.AuthProcess.Register,
            },
        });
        onClose();
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "aria-label": "bottom panel", "data-e2e": 'AccessPopupBottomPanel_Container', children: [currentUser ? ((0, jsx_runtime_1.jsx)(Link, { question: (0, i18n_1.Localized)(i18n_1.Strings.accessPopups.alreadyPurchased), onClick: onGoRestore, "data-e2e": 'AccessPopupBottomPanel_Link', children: (0, i18n_1.Localized)(i18n_1.Strings.accessPopups.restore) })) : ((0, jsx_runtime_1.jsx)(Link, { question: (0, i18n_1.Localized)(i18n_1.Strings.accessPopups.alreadyHaveAccount), onClick: onLogin, "data-e2e": 'AccessPopupBottomPanel_Link', children: (0, i18n_1.Localized)(i18n_1.Strings.accessPopups.login) })), currentUser ? ((0, jsx_runtime_1.jsx)(Button, { onClick: onStore, "data-e2e": 'AccessPopupBottomPanel_Button', children: (0, i18n_1.Localized)(i18n_1.Strings.accessPopups.gotoStore) })) : ((0, jsx_runtime_1.jsx)(Button, { onClick: onGoTry, "data-e2e": 'AccessPopupBottomPanel_Button', children: (0, i18n_1.Localized)(i18n_1.Strings.accessPopups.tryItForFree) }))] }));
}
const AccessPopupBottomPanelWithAuthProvider = (0, auth_1.withAuthProvider)(AccessPopupBottomPanel);
exports.default = AccessPopupBottomPanelWithAuthProvider;
const Container = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
const Button = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  width: 140px;
  height: 44px;

  margin: auto 0;
  padding: 0;
  font-size: 14px;
`;
const Link = (0, styled_components_1.default)(ui_1.CTALink) `
  margin: auto auto auto 0;
`;
